import get from 'lodash/get'

import { AsyncPaymentRedirectToPspResponseStatus } from './constants'

export const isAsyncPaymentRedirectToPspResponse = action =>
  get(action, 'error.response.status', false) === AsyncPaymentRedirectToPspResponseStatus
